import React, { useState, useEffect, useRef } from "react";
import usePullToRefresh from "../../Hooks/usePullToRefresh";
import { triggerHaptic } from "../../Hooks/useHaptics";
import { RotateCw, SlidersHorizontal, UsersRound } from "lucide-react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { cn } from "../../Lib/Cn";
import { Button } from "../UI/button";
import { Sheet, SheetContent } from "../UI/sheet";
import {
  Home,
  X,
  Users,
  BarChart3,
  Settings,
  FileText,
  Menu,
  ListCheck,
  Plus,
  ArrowLeft,
  LayoutDashboardIcon,
  ClipboardList,
  TrendingUp,
  ChartNoAxesCombined,
  AlignJustify,
  LogOut,
  RotateCcw,
  Banknote,
  CircleCheckBig,
  CircleCheck,
  ListTodo,
  Handshake,
  Crown,
  Funnel,
  BanknoteArrowDown,
  Filter,
  Factory,
  HeadphonesIcon,
  ShoppingCart,
  Globe,
  Sparkles,
  Search,
  History,
  UserRound,
  Clock,
  Palette,
  SquareCheckBig,
  Calendar,
  GitFork,
  ShieldCheck,
  ChevronRight,
  CheckSquare,
  Layers,
  Share2,
  KeyRound
} from "lucide-react";
import { PiMegaphoneLight } from "react-icons/pi";
import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogHeader,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "../UI/alert-dialog";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose
} from "../UI/dialog";
import {
  checkUserRights,
  currentUserHasPermission,
  getThreadMenuItems,
  isPremium,
  threadMenuItems,
  isMobileDevice,
  openInExternalBrowser,
} from "../../Utils/Utilities";
import MobileHeader from "./MobileHeader";
import { FaDownload } from "react-icons/fa6";
import { getActiveThreadTypesArr, getAgencyDetails, getThreadTypesArr, isAgencyAllowed, isSmartSellerMode, updateHeaderConfig, userIsAdmin } from "../../Store/Reducers";
import { useSelector, useDispatch } from "react-redux";
import ConnectionEntryDialog from "../../Modules/Connections/ConnectionEntry";
import ThreadEntry from "../../Modules/Threads/ThreadEntry";
import ContractEntry from "../../Modules/Contracts/ContractEntry";
import TransactionEntry from "../../Modules/Connections/Tabs/TransactionEntry";
import { isLive, isIOSDevice } from "../../Utils/Utilities";
import { getThreadTypeMeta } from "../../Utils/Utilities";
import { MobileAddPopup } from "./MobilePopup";
import { motion, AnimatePresence, m } from "framer-motion";
import TaskClassSelectorDrawer from "../../Modules/Tasks/TaskClassSelectorDrawer";
import { SHOW_EXPENSES, SHOW_LISTING, canShowImportInquiries } from "../../Utils/FeatureFlags";
import ComingSoonDialog from "../Common/ComingSoon";
import MenuDrawer from "./MenuDrawer";
import { API_CONFIG } from "../../Utils/APIConfig";
import { clearEverything, getCookie, setCookie } from "../../Utils/CookieHandler";
import { getAuthData } from "../../Utils/AuthUtils";
import TaskEntry from "../../Modules/Tasks/TaskEntry";
import RecordEntry from "../../Modules/Records/RecordsEntry";
import WebStoreConfig from "../../Modules/Settings/WebStoreConfig/WebStoreConfig";
import { getConfigData } from "../../Utils/Storage";
import FloatingFeedbackButton from "../../Modules/Ticket/FloatingTktBtn";
import { SHOW_COMMUNITY, SHOW_SHARE_APP } from "../../Utils/FeatureFlags";
import { hasFeatureAccess } from "../../Utils/Constants";
import UserEntry from "../../Modules/Users/UserEntry";
// import ChangePINDialog from "../../Modules/Users/ChangePINDialog";
import { getTransactionTypesArr } from "../../Store/Reducers";
import UpgradeSubscription from "../../Modules/Settings/UpgradeSubscription/UpgradeSubscription";
import { AlertBox } from "../Common/AlertBox";
import { checkIfInqOnlyMode } from "../../Store/Reducers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilterCircleDollar } from "@fortawesome/free-solid-svg-icons";
import ContractDropdown from "../../Modules/Connections/ContractDropdown";
import TransactionDropdown from "../../Modules/Connections/TransactionDropdown";
import ExpenseEntry from "../../Modules/Expenses/ExpenseEntry";
import useIsMobile from "../../Hooks/useIsMobile";
import { useModalBackButton } from "../../Hooks/useModalBackButton";
import { modalStackManager } from "../../Utils/ModalStackManager";
import { getImageRoot, shareWithImage } from "../../Utils/Utilities";

// const ProfileDrawer = ({ isOpen, onClose, userData, onLogout }) => {
//   return (
//     <Sheet open={isOpen} onOpenChange={onClose}>
//       <SheetContent
//         side="right"
//         className="w-[320px] sm:w-[400px] p-0 border-l border-sahi-border-color shadow-2xl"
//       >
//         <div className="flex flex-col h-full bg-white">
//           {/* Header with User Info */}
//           <div className="p-6 pt-10 border-b border-sahi-border-color bg-sahi-light-grey/30">
//             <div className="flex items-center gap-4">
//               <div className="h-16 w-16 rounded-full bg-sahi-blue-light flex items-center justify-center text-sahi-blue font-bold text-2xl border-2 border-white shadow-sm">
//                 {userData?.Name?.charAt(0) || "U"}
//               </div>
//               <div className="flex-1 min-w-0">
//                 <h3 className="text-lg font-bold text-text-color truncate">
//                   {userData?.Name || "User Name"}
//                 </h3>
//                 <p className="text-xs text-gray-500 font-medium truncate uppercase tracking-wider">
//                   {userData?.Role || "Team Member"}
//                 </p>
//               </div>
//               <button
//                 onClick={onClose}
//                 className="p-2 hover:bg-gray-200 rounded-full transition-colors"
//               >
//                 <X className="w-5 h-5 text-gray-500" />
//               </button>
//             </div>
//           </div>

//           {/* Menu Options */}
//           <div className="flex-1 overflow-y-auto py-4 px-3">
//             <div className="space-y-1">
//               <p className="px-3 text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">
//                 Account Settings
//               </p>

//               <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-sahi-light-grey transition-colors group">
//                 <div className="w-8 h-8 rounded bg-gray-100 flex items-center justify-center text-gray-600 group-hover:text-sahi-primary-color">
//                   <Settings className="w-4 h-4" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-700">
//                   Change Password
//                 </span>
//               </button>

//               <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-sahi-light-grey transition-colors group">
//                 <div className="w-8 h-8 rounded bg-gray-100 flex items-center justify-center text-gray-600 group-hover:text-sahi-primary-color">
//                   <ListCheck className="w-4 h-4" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-700">
//                   My Activity Log
//                 </span>
//               </button>
//             </div>

//             <div className="mt-6 space-y-1">
//               <p className="px-3 text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">
//                 Display
//               </p>
//               <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-sahi-light-grey transition-colors group">
//                 <div className="w-8 h-8 rounded bg-gray-100 flex items-center justify-center text-gray-600">
//                   <Users className="w-4 h-4" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-700">
//                   Profile Visibility
//                 </span>
//               </button>
//             </div>
//           </div>

//           {/* Footer / Logout */}
//           <div className="p-4 border-t border-sahi-border-color">
//             <button
//               onClick={onLogout}
//               className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-red-50 text-red-600 transition-colors group"
//             >
//               <div className="w-8 h-8 rounded bg-red-50 flex items-center justify-center group-hover:bg-red-600 group-hover:text-white transition-colors">
//                 <LogOut className="w-4 h-4" />
//               </div>
//               <span className="text-sm font-bold">Sign out</span>
//             </button>
//             <p className="text-[10px] text-center text-gray-400 mt-4">
//               SahiClub v2.0.4 • {new Date().getFullYear()}
//             </p>
//           </div>
//         </div>
//       </SheetContent>
//     </Sheet>
//   );
// };
const drawerWidth = 85;

const getBottomMenuItems = (isAdmin, onOpenChangePIN) => {
  const items = [];

  // items.push({
  //   text: "PIN",
  //   icon: KeyRound,
  //   onClick: () => onOpenChangePIN && onOpenChangePIN(),
  // });

  items.push(
    isAdmin
      ? { text: "Settings", icon: Settings, path: "/settings" }
      : { text: "Logout", icon: LogOut, onClick: () => handleLogout() }
  );

  return items;
};

const mobileHeaderOverrides = {
  "/threads": {
    actionsRight: [
      {
        icon: FaDownload,
        onClick: "openIntegrations",
      },
    ],
  },
  "/connections": {
    actionsRight: [],
  },
  "/add": {
    actionsRight: [],
  },
  "/feed": {
    actionsRight: [],
  },
  "/Records": {
    actionsRight: [],
  },
  "/records": {
    actionsRight: [],
  },
  "/loss-analysis": {
    actionsRight: [],
  },
  "/expenses": {
    actionsRight: [],
  },
  "/settings": {
    actionsRight: [
      {
        icon: LogOut,
        style: { height: "90px", width: "90px" },
        onClick: () => handleLogout(),
      },
    ],
  },
  "/correct-excel": {
    actionsRight: [
      {
        icon: FaDownload,
        style: { height: "90px", width: "90px" },
        onClick: () => console.log("Notifications for Contacts"),
      },
    ],
  },
};

// ✅ Logout function - clears session and redirects to login page
const handleLogout = () => {
  clearEverything();
};

// Mobile Popup Component
// const MobileAddPopup = ({ isOpen, onClose, threadTypes, onOptionClick }) => {
//   const [isAnimating, setIsAnimating] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       setIsAnimating(true);
//       // Add small delay for stagger effect
//       setTimeout(() => setIsAnimating(false), 150);
//     }
//   }, [isOpen]);

//   if (!isOpen) return null;

//   const handleOptionClick = (option, isConnection = false) => {
//     onOptionClick(option, isConnection);
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 z-[100] lg:hidden">
//       {/* Backdrop with blur */}
//       <div
//         className={cn(
//           "absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300",
//           isOpen ? "opacity-100" : "opacity-0"
//         )}
//         onClick={onClose}
//       />

//       {/* Popup Content */}
//       <div className="absolute bottom-0 left-0 right-0 p-3 pb-24">
//         <div className="space-y-2 max-w-xs mx-auto">
//           {/* Thread Type Options */}
//           {threadTypes.map((meta, index) => {
//             const Icon = meta.Icon;
//             return (
//               <button
//                 key={meta.name}
//                 onClick={() => handleOptionClick(meta)}
//                 className={cn(
//                   "w-full bg-white rounded-lg px-3 py-2.5 flex items-center gap-3 shadow-md",
//                   "transform transition-all duration-500 hover:scale-[1.02] active:scale-[0.98]",
//                   isAnimating
//                     ? "-translate-y-4 opacity-0" // start slightly above, invisible
//                     : "translate-y-0 opacity-100" // drop into place
//                 )}
//                 style={{
//                   transitionDelay: isAnimating ? `${index * 80}ms` : '0ms' // top to bottom
//                 }}
//               >
//                 <div
//                   className={cn(
//                     "w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0",
//                     meta.colorClass
//                   )}
//                   style={{ backgroundColor: `${meta.textColor}20` }}
//                 >
//                   <Icon className={cn("w-4 h-4", meta.colorClass)} />
//                 </div>
//                 <span className="text-gray-800 font-medium text-left flex-1 text-sm truncate">
//                   {meta.name}
//                 </span>
//               </button>
//             );
//           })}

//           {/* Connections Option */}
//           <button
//             onClick={() => handleOptionClick(null, true)}
//             className={cn(
//               "w-full bg-white rounded-lg px-3 py-2.5 flex items-center gap-3 shadow-md",
//               "transform transition-all duration-500 hover:scale-[1.02] active:scale-[0.98]",
//               isAnimating
//                 ? "-translate-y-4 opacity-0"
//                 : "translate-y-0 opacity-100"
//             )}
//             style={{
//               transitionDelay: isAnimating ? `${threadTypes.length * 80}ms` : '0ms'
//             }}
//           >
//             <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
//               <Users
//                 className="w-4 h-4"
//                 style={{ color: 'var(--sahi-blue)' }}
//               />
//             </div>
//             <span className="text-gray-800 font-medium text-left flex-1 text-sm">
//               Connection
//             </span>
//           </button>

//         </div>
//       </div>

//       {/* Close Button (Animated Plus to X) */}
//       <button
//         onClick={onClose}
//         className={cn(
//           "fixed bottom-[30px] left-1/2 -translate-x-1/2 z-50",
//           "w-14 h-14 bg-sahi-primary-color rounded-full flex items-center justify-center shadow-lg",
//           "transform transition-all duration-300 hover:scale-105"
//         )}
//       >
//         <X
//           className={cn(
//             "w-7 h-7 text-white transition-transform duration-300",
//             isOpen ? "rotate-0 scale-100" : "rotate-45 scale-75"
//           )}
//         />
//       </button>
//     </div>
//   );
// };

const Main = ({ children, onLogout, onRefresh = () => { } }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [isThreadEntryOpen, setIsThreadEntryOpen] = useState(false);
  const [selectedThreadTypeID, setSelectedThreadTypeID] = useState(null);
  const [threadEntryCalledFrom, setThreadEntryCalledFrom] = useState("");
  const [isIntegrationsOpen, setIsIntegrationsOpen] = useState(false);
  const [isProfileDrawerOpen, setIsProfileDrawerOpen] = useState(false);
  const userData = useSelector((state) => state.users?.loggedInUser); // Adjust according to your redux path

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const currentUserID = getAuthData()?.UserID;
    const savedUserID = getCookie("DefaultPageUID");

    if (currentUserID && savedUserID && String(savedUserID) !== String(currentUserID)) {
      setCookie("DefaultPage", "/");
    }
    if (currentUserID) {
      setCookie("DefaultPageUID", currentUserID);
    }

    if (location.pathname === "/") {
      const defaultPage = getCookie("DefaultPage");
      if (defaultPage && defaultPage !== "/") {
        navigate(defaultPage, { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    const handleBulkSelectionChanged = (event) => {
      setThreadBulkSelectionCount(event.detail.selectionCount);
    };

    window.addEventListener("threads-bulk-selection-changed", handleBulkSelectionChanged);
    return () => {
      window.removeEventListener("threads-bulk-selection-changed", handleBulkSelectionChanged);
    };
  }, []);

  // Handle back navigation: on any non-home page, pressing back returns to Home ("/")
  // On Home ("/"), prevent going back/exiting the app
  const currentPathRef = useRef(location.pathname);
  useEffect(() => {
    currentPathRef.current = location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    // 1. Ensure there is a history entry to catch the back button
    // This works on both Home ("/") and sub-pages so hardware back doesn't exit the app
    const currentState = (window.history.state && typeof window.history.state === "object")
      ? window.history.state
      : {};
    
    // Push an entry if not already marked so back button is always intercepted
    if (!window.history.state?.__sahiNavTrap) {
      window.history.pushState(
        { ...currentState, __sahiNavTrap: true, page: location.pathname },
        null,
        window.location.pathname
      );
    }

    const handlePopState = (event) => {
      // 2. If a modal or drawer is open or performing cleanup, DO NOT navigate!
      if (
        event?.__sahiModalHandled ||
        modalStackManager.hasOpenModals() ||
        modalStackManager.isCleaningUp()
      ) {
        return;
      }

      const activePath = currentPathRef.current;

      // 3. If user was on any non-home page and presses Back:
      // Navigate directly to Home ("/")
      if (activePath !== "/") {
        navigate("/", { replace: true });
      } else {
        // 4. If already on Home ("/"):
        // Keep them on Home (re-push trap entry)
        const stateToPreserve = (window.history.state && typeof window.history.state === "object")
          ? window.history.state
          : {};
        window.history.pushState(
          { ...stateToPreserve, __sahiNavTrap: true, page: "/" },
          null,
          "/"
        );
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate]);

  const noPaddingPages = ["/threads"]; // Add more if needed
  const threadTypes = useSelector(getActiveThreadTypesArr);
  const threadTypesAll = useSelector((state) => state.masterData.threadTypes);
  const isMobile = useIsMobile();
  const [isAddConn, setIsAddConn] = useState(false);
  const [isConnectionDialogOpen, setIsConnectionDialogOpen] = useState(false);
  const [isUserEntryOpen, setIsUserEntryOpen] = useState(false);
  const [isTaskDialogOpen, setIsTaskDialogOpen] = useState(false);
  const [isWebStoreConfigOpen, setIsWebStoreConfigOpen] = useState(false);
  const [configRefreshTrigger, setConfigRefreshTrigger] = useState(0);
  const [isInteractionDialogOpen, setIsInteractionDialogOpen] = useState(false);
  const [isExpenseEntryOpen, setIsExpenseEntryOpen] = useState(false);
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
  const [isChangePINOpen, setIsChangePINOpen] = useState(false);
  const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);
  const [showIOSAlert, setShowIOSAlert] = useState(false);
  const [threadBulkSelectionCount, setThreadBulkSelectionCount] = useState(0);
  const [mobileDropdownType, setMobileDropdownType] = useState(null); // 'contract' or 'transaction'
  const [isContractEntryOpen, setIsContractEntryOpen] = useState(false);
  const [isTransactionEntryOpen, setIsTransactionEntryOpen] = useState(false);
  const [selectedContractType, setSelectedContractType] = useState(null);
  const [selectedTransactionType, setSelectedTransactionType] = useState(null);
  const [selectedExpenseType, setSelectedExpenseType] = useState(null);
  const agencyDatas = useSelector(getAgencyDetails);
  const isInqModeForMenu = useSelector(checkIfInqOnlyMode);
  const canViewOrderHistory = (threadTypes.find((t) => t.TID === 2)?.Sh === true) || isInqModeForMenu;

  const [selectedTasksDate, setSelectedTasksDate] = useState(new Date());
  const [hasOtherTaskClasses, setHasOtherTaskClasses] = useState(false);
  const [isTaskClassDrawerOpen, setIsTaskClassDrawerOpen] = useState(false);
  const [taskPrefillData, setTaskPrefillData] = useState(null);

  useEffect(() => {
    const handleDateChange = (e) => {
      if (e.detail) {
        if (e.detail.date) {
          setSelectedTasksDate(new Date(e.detail.date));
          setHasOtherTaskClasses(!!e.detail.hasOtherTaskClasses);
        } else {
          setSelectedTasksDate(new Date(e.detail));
        }
      }
    };
    window.addEventListener('tasks-date-changed', handleDateChange);
    return () => {
      window.removeEventListener('tasks-date-changed', handleDateChange);
    };
  }, []);

  useEffect(() => {
    const handleConfigChange = () => setConfigRefreshTrigger((prev) => prev + 1);
    window.addEventListener("config-updated", handleConfigChange);
    return () => window.removeEventListener("config-updated", handleConfigChange);
  }, []);

  // Dynamically update document title based on the active tab/path
  useEffect(() => {
    let pageTitle = "";
    const path = location.pathname.toLowerCase();

    // if (path === "/" || path === "/dashboard") {
    //   pageTitle = "SahiClub";
    // } else
    if (path === "/connections") {
      pageTitle = "Contacts";
    } else if (path === "/threads") {
      pageTitle = isInqModeForMenu ? "Inquiries" : "Threads";
    } else if (path === "/kanban") {
      pageTitle = "Kanban";
    } else if (path === "/tasks") {
      pageTitle = "Tasks";
    } else if (path === "/contracts") {
      pageTitle = "Contracts";
    } else if (path === "/transactions") {
      pageTitle = "Transactions";
    } else if (path === "/expenses") {
      pageTitle = "Expenses";
    } else if (path === "/reports") {
      pageTitle = "Reports";
    } else if (path === "/settings") {
      pageTitle = "Settings";
    } else if (path === "/activity") {
      pageTitle = "Usage MIS";
    } else if (path === "/growth") {
      pageTitle = "Growth";
    } else if (path === "/community") {
      pageTitle = "Network";
    } else if (path === "/listing" || path === "/directory") {
      pageTitle = "Directory";
    } else if (path.includes("/threads-report")) {
      const params = new URLSearchParams(location.search);
      pageTitle = params.get("tID") === "2" ? "Sales" : "Reports";
    } else if (path === "/loss-analysis") {
      pageTitle = "Loss Analysis";
    } else if (path === "/correct-excel") {
      pageTitle = "Correct Excel";
    } else {
      const cleanPath = location.pathname.replace("/", "").replace("-", " ");
      if (cleanPath) {
        pageTitle = cleanPath.charAt(0).toUpperCase() + cleanPath.slice(1);
      }
    }

    document.title = pageTitle ? `${pageTitle} - SahiClub` : "SahiClub";
  }, [location.pathname, isInqModeForMenu]);

  const handleShareApp = async (e) => {
    if (e) e.stopPropagation();
    const refCode = ""; // agencyDatas?.AgencyID || agencyDatas?.agencyID || agencyDatas?.Mobile || agencyDatas?.mobile || "";
    const downloadUrl = refCode ? `https://sahi.club/app?ref=${refCode}` : "https://sahi.club/app";
    const shareTitle = "Sahi Club";
    const shareText = `I use Sahi Club to run my smart business\nJoin for free using my reference and the app download link:\n${downloadUrl}`;
    const shareCardUrl = getImageRoot("Images", "SahiClub_BG.png");

    await shareWithImage({
      title: shareTitle,
      text: shareText,
      url: downloadUrl,
      imageUrl: shareCardUrl,
      imageFileName: "SahiClub_BG.png",
      successCopyMessage: "App invite link copied to clipboard!"
    });
  };

  const maxUsers = agencyDatas?.CntMaxUsers || 0;
  const defaultMainMenuItems = [
    {
      text: "Dashboard",
      icon: LayoutDashboardIcon,
      path: "/",
      className: "",
      show: true,
    },
    {
      text: "Contacts",
      icon: Users,
      path: "/connections",
      className: "text-xs",
      show: true,
    },
    {
      text: "Threads",
      icon: ClipboardList,
      iconType: "lucide",
      path: "/threads",
      className: "",
      show: true,
    },
    {
      text: "Inquiries",
      icon: Funnel,
      iconType: "lucide",
      path: "/threads",
      className: "",
      show: false,
    },
    {
      text: "Sales",
      id: "order-history-report",
      label: "Sales",
      icon: ShoppingCart,
      path: `/threads-report?tID=2&m=${new Date().getMonth() + 1}`,
      show: canViewOrderHistory,
    },
    {
      text: "Support",
      id: "support-tickets-report",
      label: "Support Tickets",
      icon: HeadphonesIcon,
      path: `/threads-report?tID=3&m=${new Date().getMonth() + 1}`,
      show: [1].includes(Number(agencyDatas?.AgencyID))
    },
    {
      text: "Tasks",
      icon: ListTodo,
      path: "/tasks",
      className: "",
      show: true,
    },
    {
      text: "Contracts",
      icon: FileText,
      path: "/contracts",
      className: "",
      show: true,
    },
    {
      text: "Transactions",
      icon: Handshake,
      path: "/transactions",
      className: "",
      show: true,
    },
    {
      text: "Expenses",
      icon: BanknoteArrowDown,
      path: "/expenses",
      className: "",
      show: false, // !isSmartSellerMode(),
    },
    {
      text: "Reports",
      icon: BarChart3,
      path: "/reports",
      className: "",
      show: true,
    },
    {
      text: "Network",
      icon: Globe,
      path: hasFeatureAccess("community") ? "/community" : "/directory",
      comingSoon: !SHOW_LISTING(),
      className: "",
      show: true,
    },
  ];
  const defaultRoutesInfo = [
    {
      text: "Home",
      icon: Home,
      path: "/",
      showInMobNav: true,
      show: true,
    },
    {
      text: "Threads",
      icon: ListCheck,
      iconType: "lucide",
      path: "/threads",
      showInMobNav: false,
      show: false,
    },
    // {
    //   text: "Inquiries",
    //   icon: Funnel,
    //   iconType: "lucide",
    //   path: "/threads",
    //   showInMobNav: true,
    //   show: false,
    // },
    // {
    //   text: "Add",
    //   icon: Plus,
    //   path: "/add",
    //   isAddButton: true,
    //   showInMobNav: true,
    //   show: true,
    // },
    // { text: "Feed", icon: FileText, path: "/feed", comingSoon: true, showInMobNav: true, show: true },
    {
      text: "Growth",
      icon: ChartNoAxesCombined,
      path: "/growth",
      showInMobNav: true,
      show: true,
    },
    {
      text: "Tasks",
      icon: ListTodo,
      path: "/tasks",
      showInMobNav: true,
      show: true,
    },
    {
      text: "Network",
      icon: Globe,
      path: hasFeatureAccess("community") ? "/community" : "/directory",
      showInMobNav: true,
      show: true,
    },
    {
      text: "Settings",
      icon: FileText,
      path: "/settings",
      isAddButton: false,
      showInMobNav: false,
      show: true,
    },
    {
      text: "Settings",
      icon: Settings,
      path: "/settings",
      showInMobNav: true,
      show: false,
    },
  ];

  const isInqMode = useSelector(checkIfInqOnlyMode);
  const isAdmin = useSelector(userIsAdmin);
  const [mainMenuItems, setMainMenuItems] = useState(defaultMainMenuItems);
  const [routesInfo, setRoutesInfo] = useState(defaultRoutesInfo);
  const agencyData = useSelector(getAgencyDetails);

  const isAgencyAuthorized = useSelector(isAgencyAllowed);

  const userRights = checkUserRights();

  useModalBackButton(showMobilePopup, setShowMobilePopup, "mobile-add-popup");

  useEffect(() => {
    const inquiryPath = isInqMode && !isMobile ? "/kanban?tid=1" : "/threads";
    setMainMenuItems((prevItems) =>
      prevItems.map((item) => {
        // Logic to force both visible for Agency ID 1

        if (item.text === "Threads") {
          return { ...item, show: !isInqMode, path: "/threads" };
        }
        if (item.text === "Inquiries") {
          return { ...item, show: isAgencyAuthorized || isInqMode, path: inquiryPath };
        }
        if (item.text === "Contracts") {
          return { ...item, show: agencyData.EnblContracts && userRights.addCtrcs };
        }
        if (item.text === "Transactions") {
          return { ...item, show: agencyData.EnblXns && userRights.addTxn };
        }
        if (item.text === "Expenses")
          return { ...item, show: SHOW_EXPENSES() && userRights?.agnConfig && !isSmartSellerMode() };

        if (item.text === "Orders") {
          return { ...item, show: canViewOrderHistory };
        }
        if (item.text === "Support") {
          return { ...item, show: [1].includes(Number(agencyData?.AgencyID)) };
        }
        if (item.text === "Network") {
          return {
            ...item,
            path: hasFeatureAccess("community") ? "/community" : "/directory",
            comingSoon: !SHOW_LISTING(),
          };
        }
        return item;
      })
    );
    setRoutesInfo((prevRoutes) =>
      prevRoutes.map((item) => {
        if (item.text === "Threads") {
          // Always hidden from the mobile bottom nav (showInMobNav: false).
          return { ...item, show: false, path: "/threads" };
        }
        if (item.text === "Inquiries") {
          return { ...item, show: isInqMode, path: inquiryPath };
        }
        if (item.text === "Settings" && item.showInMobNav) {
          return { ...item, show: isAdmin };
        }
        if (item.text === "Network") {
          return { ...item, path: hasFeatureAccess("community") ? "/community" : "/directory" };
        }
        return item;
      })
    );
  }, [
    isInqMode,
    agencyData.EnblContracts,
    agencyData.EnblXns,
    agencyData?.AgencyID,
    userRights.agnConfig,
    canViewOrderHistory,
    isAdmin,
  ]);

  const isGlobalLoading = useSelector(
    (state) => state.globalLoader.isGlobalLoading
  );
  const bottomMenuItems = getBottomMenuItems(isAdmin, () => setIsChangePINOpen(true));

  // Get user permissions for mobile popup
  const canAddConnections = currentUserHasPermission("ConnEntry");
  const canAddTasks = currentUserHasPermission("TaskEntry");
  const canAddRecords = currentUserHasPermission("RecordEntry");

  const [tasksViewMode, setTasksViewMode] = useState(() => localStorage.getItem("TasksViewMode") || "watch");

  const toggleTasksViewMode = () => {
    if (isMobile) {
      window.dispatchEvent(new CustomEvent("tasks-toggle-view-mode"));
    } else {
      const nextMode = tasksViewMode === "watch" ? "category" : (tasksViewMode === "category" ? "class" : "watch");
      localStorage.setItem("TasksViewMode", nextMode);
      setTasksViewMode(nextMode);
      window.dispatchEvent(new CustomEvent("tasks-toggle-view-mode", { detail: nextMode }));
    }
  };

  useEffect(() => {
    const handleSyncViewMode = (e) => {
      if (e.detail) {
        setTasksViewMode(e.detail);
      }
    };
    window.addEventListener("tasks-view-mode-changed", handleSyncViewMode);
    return () => {
      window.removeEventListener("tasks-view-mode-changed", handleSyncViewMode);
    };
  }, []);

  // Get thread type metas
  const threadMetas = threadTypes.map((type) => {
    let threadMetaData = getThreadTypeMeta(type.TID, threadTypes) || {};
    return { ...threadMetaData, tID: type.TID, Sh: type.Sh };
  });

  // Get transaction types from Redux
  const allTransactionTypes = useSelector(getTransactionTypesArr);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      // Close mobile drawer on desktop
      if (window.innerWidth >= 1024) {
        setMobileOpen(false);
        setShowMobilePopup(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Function for checking URL is from live or not

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuItemClick = (item) => {
    if (item.comingSoon) {
      setComingSoonOpen(true);
      return;
    }

    // Handle upgrade
    if (item.path === "/upgrade") {
      setIsUpgradeOpen(true);
      setMobileOpen(false);
      return;
    }

    if (item.isProfileTrigger) {
      setIsProfileDrawerOpen(true);
      setIsMenuDrawerOpen(false); // Closes the mobile top menu if it's open
      setMobileOpen(false); // Closes the side menu if it's open
      return;
    }

    // Handle settings special case
    if (item.path === "/settings") {
      console.log("Message");
      if (location.pathname !== "/settings") {
        setCookie("DefaultPage", "/settings");
        navigate("/settings");
      }
      setMobileOpen(false);
      setIsMenuDrawerOpen(false);
      return;
    }

    // Handle logout
    if (item.isLogout) {
      handleLogout();
      setMobileOpen(false);
      return;
    }

    // Warn if leaving /correct-excel with unsaved changes
    if (location.pathname === "/correct-excel") {
      const leave = window.confirm(
        "You have unsaved changes. Do you really want to leave?"
      );
      if (!leave) return; // cancel navigation
    }

    // Special handling for settings to force refresh
    if (item.path) {
      setCookie("DefaultPage", item.path);
    }
    navigate(item.path);
    setMobileOpen(false);
  };

  const handleBottomNavClick = (item) => {
    if (item.comingSoon) {
      setComingSoonOpen(true);
      return;
    }
    // Handle upgrade
    if (item.path === "/upgrade") {
      setIsUpgradeOpen(true);
      return;
    }
    if (item.isAddButton) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + 3);
      maxDate.setHours(23, 59, 59, 999);
      const selDate = new Date(selectedTasksDate || today);
      selDate.setHours(0, 0, 0, 0);
      const shouldShowDrawer = !isDesktop && location.pathname === "/tasks" && hasOtherTaskClasses && selDate >= today && selDate <= maxDate;

      if (shouldShowDrawer) {
        setIsTaskClassDrawerOpen(true);
        return;
      }

      if (location.pathname === "/connections" && canAddConnections) {
        setIsConnectionDialogOpen(true);
        return;
      } else if (location.pathname === "/users") {
        setIsUserEntryOpen(true);
        return;
      } else if (location.pathname === "/tasks") {
        setIsTaskDialogOpen(true);
        return;
      } else if (location.pathname === "/listing" || location.pathname === "/directory") {
        setIsWebStoreConfigOpen(true);
        return;
      } else if (location.pathname === "/contracts") {
        setMobileDropdownType("contract");
        return;
      } else if (location.pathname === "/transactions") {
        setMobileDropdownType("transaction");
        return;
      } else if (location.pathname === "/threads") {
        const filteredThreadTypes = isInqMode
          ? threadTypes.filter((tt) => tt.Sh !== false)
          : threadTypes;

        if (filteredThreadTypes.length === 1) {
          setSelectedThreadTypeID(filteredThreadTypes[0].TID || 1);
          setIsThreadEntryOpen(true);
          return;
        } else if (filteredThreadTypes.length > 1) {
          setShowMobilePopup(true);
          return;
        }
        setShowMobilePopup(true);
        return;
      } else if (location.pathname === "/connections" && !canAddConnections) {
        // Show popup but without connection option if no permission
        setShowMobilePopup(true);
        return;
      } else if (location.pathname === "/expenses") {
        setIsExpenseEntryOpen(true);
        return;
      } else if (location.pathname.toLowerCase() === "/community") {
        window.dispatchEvent(new Event("open-community-post"));
        return;
      } else if (location.pathname === "/growth") {
        const params = new URLSearchParams(location.search);
        const growthTab = params.get("tab") || "inquiries";
        if (growthTab === "sales") {
          setSelectedThreadTypeID(2);
          setThreadEntryCalledFrom(isInqMode ? "ORDDONE" : "");
          setIsThreadEntryOpen(true);
          return;
        } else if (growthTab === "inquiries") {
          setSelectedThreadTypeID(1);
          setThreadEntryCalledFrom("");
          setIsThreadEntryOpen(true);
          return;
        } else if (growthTab === "contacts") {
          if (canAddConnections) {
            setIsConnectionDialogOpen(true);
          } else {
            setShowMobilePopup(true);
          }
          return;
        }
      } else if (location.pathname === "/threads-report") {
        const params = new URLSearchParams(location.search);
        const tID = params.get("tID");
        if (tID) {
          setSelectedThreadTypeID(parseInt(tID));
          setThreadEntryCalledFrom(isInqMode ? "ORDDONE" : "");
          setIsThreadEntryOpen(true);
          return;
        }
        setShowMobilePopup(true);
        return;
      } else if (location.pathname === "/" && isInqMode) {
        setSelectedThreadTypeID(threadTypes[0]?.TID || 1);
        setIsThreadEntryOpen(true);
        return;
      } else {
        // Show mobile popup instead of alert
        setShowMobilePopup(true);
        return;
      }
    }
    if (item.path) {
      if (location.pathname !== item.path) {
        triggerHaptic("soft");
      }
      setCookie("DefaultPage", item.path);
    }
    navigate(item.path);
  };

  const handleMobilePopupOptionClick = (meta, dialogOpenType) => {
    if (dialogOpenType === "Contact" && !meta.isThread) {
      setIsConnectionDialogOpen(true);
    } else if (dialogOpenType === "Task" && !meta.isThread) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + 3);
      maxDate.setHours(23, 59, 59, 999);
      const selDate = new Date(selectedTasksDate || today);
      selDate.setHours(0, 0, 0, 0);
      const shouldShowDrawer = !isDesktop && location.pathname === "/tasks" && selDate >= today && selDate <= maxDate;
      if (shouldShowDrawer) {
        setIsTaskClassDrawerOpen(true);
      } else {
        setIsTaskDialogOpen(true);
      }
    } else if (dialogOpenType === "Interaction" && !meta.isThread) {
      setIsInteractionDialogOpen(true);
    } else if (meta.isThread) {
      // Handle thread type selection - open ThreadEntry with specific threadTypeID
      setSelectedThreadTypeID(meta.tID || 1);
      setIsThreadEntryOpen(true);
    } else if (dialogOpenType === "Contract") {
      // Open contract dropdown directly
      setShowMobilePopup(false);
      setMobileDropdownType("contract");
    } else if (dialogOpenType === "Transaction") {
      // Open transaction dropdown directly
      setShowMobilePopup(false);
      setMobileDropdownType("transaction");
    } else if (dialogOpenType === "Expense") {
      setIsExpenseEntryOpen(true);
      setMobileDropdownType("expense");
    }
  };

  const handleComingSoonClose = () => {
    setComingSoonOpen(false);
  };

  const useMobileHeaderConfig = () => {
    const navigate = useNavigate();
    const { search } = useLocation();

    // Get tID from URL search params
    const params = new URLSearchParams(search);
    const tID = params.get("tID");
    const typeId = params.get("typeId");

    // Find thread type label
    const getThreadTypeLabel = () => {
      if (!tID) return "Threads History";

      const threadType = threadTypesAll.find(
        (type) => type.TID === parseInt(tID)
      );

      return threadType ? `${threadType.TypSng} History` : "Threads History";
    };

    const getCustomerAnalysisTitle = () => {
      if (typeId === "1") return "Biggest Customers";
      if (typeId === "2") return "Happiest Customers";
      if (typeId === "3") return "Unhappy Customers";
      return "Customer Analysis";
    };

    const config = {};
    const routes = routesInfo;

    routes.forEach((item) => {
      if (item.comingSoon || item.isAddButton) return;

      const cleanPath = item.path.split("?")[0];
      const overrides = mobileHeaderOverrides[cleanPath] || {};

      // Process actionsRight to replace string identifiers with actual functions
      const processedActions =
        overrides.actionsRight
          ?.filter((action) => {
            if (action.onClick === "openIntegrations") {
              return userRights?.addThr && canShowImportInquiries();
            }
            return true;
          })
          .map((action) => {
            if (action.onClick === "openIntegrations") {
              return { ...action, onClick: () => setIsIntegrationsOpen(true) };
            }
            return action;
          }) || [];

      config[cleanPath] = {
        title: item.text,
        iconLeft: {
          icon: ArrowLeft,
          onClick: () => navigate("/", { replace: true }),
        },
        actionsRight: processedActions,
        ...(cleanPath === "/threads" && {
          hasSelection: threadBulkSelectionCount > 0,
          onReassignClick: () => window.dispatchEvent(new CustomEvent("open-threads-reassign-dialog"))
        }),
      };
    });
    const recordTypesData = useSelector((state) => state.masterData.recordTypes || []);

    const dynamicVisitID = recordTypesData?.find(
      (rt) => rt.Typ === "Visit" || rt.Typ === "Visit Log" || rt.Typ === "visit"
    )?.TID?.toString();
    const iid = params.get("iid");
    const recordsTitle = iid === dynamicVisitID ? "Visit Log" : "Team Efforts Log";

    config["/records"] = {
      title: recordsTitle,
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight:
        [
          {
            icon: Filter,
            onClick: () =>
              window.dispatchEvent(
                new CustomEvent("open-team-efforts-log-filter")
              ),
          },
        ],
    };

    const lossAnalysisTitle =
      params.get("rType") === "2"
        ? "Disqualification Analysis"
        : "Failure Analysis";
    config["/loss-analysis"] = {
      title: lossAnalysisTitle,
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(new CustomEvent("open-loss-analysis-filter")),
        },
      ],
    };
    config["/transactions"] = {
      title: "Transactions",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/transaction"]?.actionsRight || [],
    };
    config["/segment-analysis"] = {
      title: "Segment Analysis",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(
              new CustomEvent("open-segment-analysis-filter")
            ),
        },
      ],
    };

    config["/region-analysis"] = {
      title: "Region Analysis",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(
              new CustomEvent("open-region-analysis-filter")
            ),
        },
      ],
    };

    config["/contracts"] = {
      title: "Contracts",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/contracts"]?.actionsRight || [],
    };
    config["/tasks"] = {
      title: "Tasks",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/tasks"]?.actionsRight || [],
    };
    config["/community"] = {
      title: "Network",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/community"]?.actionsRight || [],
    };
    config["/integrations"] = {
      title: "Integrations",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/integrations"]?.actionsRight || [],
    };
    config["/threads-report"] = {
      title: isInqMode && params.get("tID") === "2" ? "Sales" : getThreadTypeLabel(),
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(
              new CustomEvent("open-threads-filter")
            ),
        },
      ],
    };
    config["/users"] = {
      title: "Users",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/users"]?.actionsRight || [],
    };
    config["/effort-log"] = {
      title: "Team Efforts Summary Log",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(
              new CustomEvent("open-efforts-log-filter")
            ),
        },
      ],
    };
    config["/product-demand"] = {
      title: "Product Demand",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: [
        {
          icon: Filter,
          onClick: () =>
            window.dispatchEvent(new CustomEvent("open-product-demand-filter")),
        },
      ],
    };
    config["/customer-analysis"] = {
      title: getCustomerAnalysisTitle(),
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight:
        typeId === "2" || typeId === "3"
          ? []
          : [
            {
              icon: Filter,
              onClick: () =>
                window.dispatchEvent(
                  new CustomEvent("open-customer-analysis-filter")
                ),
            },
          ],
    };
    const isLostCustomerReport = params.has("na") || params.has("NA");
    config["/connections"] = {
      title: isLostCustomerReport ? "Lost Customer Report" : "Contacts",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/connections"]?.actionsRight || [],
    };

    config["/expenses"] = {
      title: "Expenses",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/expenses"]?.actionsRight || [],
    };
    config["/reports"] = {
      title: "Reports",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate("/", { replace: true }),
      },
      actionsRight: mobileHeaderOverrides["/reports"]?.actionsRight || [],
    };

    return config;
  };

  const headersConfig = useMobileHeaderConfig();
  const basePath = location.pathname;

  // Set header config on path change
  useEffect(() => {
    if (basePath === "/tasks" || basePath === "/settings") return;
    const selectedHeader = headersConfig[basePath];
    dispatch(updateHeaderConfig(selectedHeader));
  }, [basePath, dispatch]);

  // Update header config when bulk selection changes
  useEffect(() => {
    if (basePath === "/tasks" || basePath === "/settings") return;
    const selectedHeader = headersConfig[basePath];
    dispatch(updateHeaderConfig(selectedHeader));
  }, [threadBulkSelectionCount, basePath, dispatch]);

  const mobileHeader = useSelector((state) => state?.headerConfigData?.data);

  const renderMenuItem = (item, isMobile = false) => {
    const Icon = item.icon;
    // Fix active state logic - ensure exact path matching
    // const isActive = location.pathname === item.path && !item.comingSoon;

    const isNetworkActive = !item.comingSoon && (item.path === "/directory" || item.path === "/listing" || item.path === "/community") && (
      location.pathname === "/directory" ||
      location.pathname === "/listing" ||
      location.pathname === "/community"
    );

    const isActive = isNetworkActive || (isAgencyAuthorized
      ? (
        (item.text === "Inquiries" && (location.pathname === "/threads" || location.pathname === "/threads-detail" || (location.pathname === "/kanban" && new URLSearchParams(location.search).get("tid") === "1"))) ||
        (item.text === "Support" && location.pathname === "/threads-report" && new URLSearchParams(location.search).get("tID") === "3") ||
        (item.text === "Orders" && location.pathname === "/threads-report" && (new URLSearchParams(location.search).get("tID") === "2" || new URLSearchParams(location.search).get("tid") === "2")) ||
        (location.pathname === item.path && !item.comingSoon && item.text !== "Inquiries" && item.text !== "Support" && item.text !== "Orders")
      )
      : (
        (item.text === "Inquiries" && (location.pathname === "/threads" || location.pathname === "/threads-detail" || (location.pathname === "/kanban" && new URLSearchParams(location.search).get("tid") === "1"))) ||
        (item.text === "Support" && location.pathname === "/threads-report" && new URLSearchParams(location.search).get("tID") === "3") ||
        (item.text === "Orders" && location.pathname === "/threads-report" && (new URLSearchParams(location.search).get("tID") === "2" || new URLSearchParams(location.search).get("tid") === "2")) ||
        (location.pathname === item.path && !item.comingSoon && item.text !== "Orders")
      ));

    const isFontAwesome = item.iconType === "fontawesome";

    const LinkComponent = (item.onClick || item.comingSoon || !item.path) ? "button" : Link;
    const linkProps = (LinkComponent === Link)
      ? {
        to: item.path,
        onClick: (e) => {
          e.preventDefault();
          handleMenuItemClick(item);
        }
      }
      : {
        type: "button",
        onClick: () => {
          if (item.onClick) {
            item.onClick();
          } else {
            handleMenuItemClick(item);
          }
        }
      };

    return (
      <li key={item.text} className="mb-2">
        <LinkComponent
          {...linkProps}
          className={cn(
            "group flex items-center justify-start w-full rounded-lg transition-all duration-200 relative text-left",
            "hover:bg-sahi-light-grey hover:shadow-sm focus:outline-none focus:ring-0 focus:bg-transparent active:bg-sahi-light-grey",
            isActive
              ? "bg-sahi-light-grey text-sahi-primary-color shadow-sm"
              : "text-dropdown-grey hover:text-sahi-primary-color",
            // Mobile: horizontal layout with proper padding
            isMobile
              ? "py-4 px-4 min-h-[56px] gap-4"
              : "flex-col py-3 px-2 min-h-[72px]"
          )}
        >
          <div
            className={cn(
              "flex items-center justify-center transition-all duration-200",
              "group-hover:scale-110 group-hover:transform",
              isActive ? "scale-105" : "",
              isMobile ? "flex-shrink-0" : "mb-1.5"
            )}
          >
            {isFontAwesome ? (
              <FontAwesomeIcon
                icon={Icon}
                className={cn(
                  "w-6 h-6 transition-all duration-200",
                  isActive
                    ? "text-sahi-primary-color"
                    : "text-dropdown-grey group-hover:text-sahi-primary-color",
                  item?.className ? item.className : ""
                )}
              />
            ) : (
              <Icon
                className={cn(
                  "w-6 h-6 transition-all duration-200 stroke-[1.5]",
                  isActive
                    ? "text-sahi-primary-color"
                    : "text-dropdown-grey group-hover:text-sahi-primary-color",
                  item?.className ? item.className : ""
                )}
              />
            )}
          </div>
          <span
            className={cn(
              "font-medium transition-colors duration-200",
              isActive
                ? "text-sahi-primary-color"
                : "text-dropdown-grey group-hover:text-sahi-primary-color",
              isMobile
                ? "text-base flex-1 text-left"
                : "text-[10px] text-center leading-tight max-w-full px-0"
            )}
          >
            {item.text}
          </span>

          {/* Active indicator */}
          {isActive && (
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-1 h-8 bg-sahi-primary-color rounded-r-full"></div>
          )}
        </LinkComponent>
      </li>
    );
  };

  const renderBottomNavItem = (item) => {
    const Icon = item.icon;
    const isFontAwesome = item.iconType === "fontawesome";
    const isNetworkTab = item.path === "/directory" || item.path === "/community";
    const isNetworkCurrent = isListingPage || isCommunityPage;
    const isActive =
      !item.comingSoon &&
      !item.isAddButton &&
      (isNetworkTab
        ? isNetworkCurrent
        : ((item.path === "/" && location.pathname === "/") ||
          (item.path !== "/" && location.pathname === item.path)));

    if (item.isAddButton) {
      // Community already has its own floating add button (FloatingFeedbackButton), so
      // don't show this generic one on top of it there.
      if (isCommunityPage) return null;
      return (
        <button
          key={item.text}
          onClick={() => handleBottomNavClick(item)}
          className={cn(
            "fixed bottom-[40px] left-1/2 -translate-x-1/2 z-50 flex flex-col items-center justify-center",
            showMobilePopup && "pointer-events-none" // Disable when popup is open
          )}
        >
          <div
            className={cn(
              "w-14 h-14 bg-sahi-primary-color rounded-full flex items-center justify-center shadow-lg",
              "transform transition-all duration-300 hover:scale-105",
              showMobilePopup ? "scale-105" : "scale-100"
            )}
          >
            <div
              className={cn(
                "transition-transform duration-300",
                showMobilePopup ? "rotate-45" : "rotate-0"
              )}
            >
              <Icon className="w-7 h-7 text-white" />
            </div>
          </div>
        </button>
      );
    }

    return (
      <button
        key={item.text}
        onClick={() => handleBottomNavClick(item)}
        className={cn(
          "relative flex flex-col items-center justify-evenly py-1 px-1 sm:px-2 transition-colors duration-200 min-w-[50px] sm:min-w-[60px]",
          "text-sahi-primary-color"
        )}
      >
        {/* Icon + halo */}
        <motion.div
          className="relative"
          initial={false}
          animate={isActive ? { scale: 1.08, y: -1 } : { scale: 1, y: 0 }}
          whileTap={{ scale: 0.95 }}
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 28,
            mass: 0.4,
          }}
        >
          {/* soft glow behind icon when active */}
          <AnimatePresence>
            {isActive && (
              <motion.span
                key="halo"
                className="absolute inset-[-8px] rounded-full bg-sahi-primary-color/15 blur-md"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25 }}
              />
            )}
          </AnimatePresence>

          {isFontAwesome ? (
            <FontAwesomeIcon
              icon={Icon}
              className={cn(
                "relative z-10 w-5 h-5 mb-1 transition-colors duration-300",
                "text-sahi-primary-color"
              )}
            />
          ) : (
            <Icon
              className={cn(
                "relative z-10 w-5 h-5 mb-1 transition-colors duration-300",
                "text-sahi-primary-color"
              )}
            />
          )}
        </motion.div>

        {/* Label */}
        <span
          className={cn(
            "text-xs font-medium leading-tight transition-colors duration-300",
            "text-sahi-primary-color"
          )}
        >
          {item.text}
        </span>

        {/* Sleek underline indicator */}
        <AnimatePresence>
          {isActive && (
            <div className="absolute bottom-0 left-0 right-0 flex justify-center">
              <motion.span
                key="underline"
                className="h-[3px] w-6 rounded-full bg-sahi-primary-color"
                initial={{ opacity: 0, scaleX: 0.6 }}
                animate={{ opacity: 1, scaleX: 1 }}
                exit={{ opacity: 0, scaleX: 0.6 }}
                transition={{ type: "spring", stiffness: 400, damping: 30 }}
              />
            </div>
          )}
        </AnimatePresence>
      </button>
    );
  };

  const DrawerContent = ({ isMobile = false }) => (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white flex justify-center items-center py-0 h-16 min-h-[64px] border-sahi-border-color">
        <div className="flex flex-col items-center gap-2">
          <img
            src={
              isLive()
                ? "/Web/assets/Images/SahiCRM_Short_dark.png"
                : "/assets/Images/SahiCRM_Short_dark.png"
            }
            alt="SahiCRMs"
            className="w-12 h-12"
          />
        </div>
      </div>

      {/* Main Menu Items - Scrollable */}
      <div
        className="flex-1 overflow-y-auto px-1 py-3 scrollbar-hide"
        style={{ paddingTop: "50px" }}
      >
        <ul className="p-0 list-none space-y-1 whitespace-normal">
          {mainMenuItems.map((item) => {
            if (item.show) {
              return renderMenuItem(item, isMobile);
            }
          })}
        </ul>
      </div>

      {/* Bottom Menu Items - Sticky at bottom */}
      <div className="px-2 pb-3 pt-2 border-t border-sahi-border-color bg-white">
        <ul className="p-0 list-none space-y-1">
          {bottomMenuItems.map((item) => renderMenuItem(item, isMobile))}
        </ul>
      </div>
    </div>
  );

  const fullHeightPages = [
    "/correct-excel",
    "/correct-excel-threads",
    "/correct-excel-transactions",
    "/listing",
    "/directory",
    "/community",
  ]; // Pages that need full viewport height

  const isHomePage = location.pathname === "/";
  const isConnectionPage = location.pathname === "/connections";
  const isReportPage = location.pathname === "/loss-analysis";
  const isProductDemandPage = location.pathname === "/product-demand";
  const isCstrAn = location.pathname === "/customer-analysis";
  const isSegAn = location.pathname === "/segment-analysis";
  const isRegShAn = location.pathname === "/region-analysis";

  const isCommunityPage = location.pathname.toLowerCase() === "/community";
  const isTasksPage = location.pathname.toLowerCase() === "/tasks";
  const isSettingsPage = location.pathname.toLowerCase() === "/settings";
  const isGrowthPage = location.pathname.toLowerCase() === "/growth";
  const isListingPage = location.pathname.toLowerCase() === "/listing" || location.pathname.toLowerCase() === "/directory";

  const isListingConfigured = isListingPage && (() => {
    const config = getConfigData();
    const indId = Number(config?.IndustryID ?? config?.industryID) || 0;
    const segId = Number(config?.SegmentID ?? config?.segmentID) || 0;
    return indId !== 0 && segId !== 0;
  })();
  const shouldHideMobileAddButton = location.pathname === "/settings" || isListingConfigured;
  const isReportConnectionPage = isConnectionPage && (new URLSearchParams(location.search).has("na") || new URLSearchParams(location.search).has("NA"));
  const showBrandHeader = isHomePage || isCommunityPage || isTasksPage || isSettingsPage || (isConnectionPage && !isReportConnectionPage) || isGrowthPage || isListingPage;

  return (
    <div className="flex min-h-screen bg-bg-grey ">
      {/* Header - Only on home page and responsive */}
      {(showBrandHeader || (!isDesktop && mobileHeader)) && (
        <header
          className={cn(
            " fixed top-0 text-black h-16 flex items-center lg:hidden justify-center z-50 transition-all duration-200 ",
            "left-0 right-0 bg-sahi-white",
            !showBrandHeader && "bg-sahi-primary-color",
            isDesktop && isHomePage && "lg:left-[85px]"
          )}
        >
          {showBrandHeader && (
            <div className="flex items-center justify-between w-full px-4 h-16 bg-white border-b border-sahi-border-color">
              <img
                src={
                  isLive()
                    ? "/Web/assets/Images/SahiLogo.png"
                    : "/assets/Images/SahiLogo.png"
                }
                alt="SahiClub Logo"
                className="h-7 md:h-9 cursor-pointer"
                onClick={() => {
                  setCookie("DefaultPage", "/");
                  navigate("/");
                }}
              />
              <div className="flex items-center gap-1">
                {isTasksPage && (
                  <>
                    <Button variant="ghost" size="icon" onClick={() => window.dispatchEvent(new CustomEvent("tasks-toggle-search"))}>
                      <Search className="h-5 w-5" />
                    </Button>
                    <Button variant="ghost" size="icon" className="relative" onClick={() => window.dispatchEvent(new CustomEvent("tasks-toggle-history"))}>
                      <History className="h-5 w-5" />
                      {mobileHeader?.actionsRight?.find((a) => a.icon === History)?.showBadge && (
                        <span
                          className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full border border-white z-10 pointer-events-none"
                          style={{ backgroundColor: mobileHeader?.actionsRight?.find((a) => a.icon === History)?.badgeColor || '#0B5D1E' }}
                        />
                      )}
                    </Button>
                    <Button variant="ghost" size="icon" className="relative" onClick={() => window.dispatchEvent(new CustomEvent("tasks-toggle-filter"))}>
                      <Filter className="h-5 w-5" />
                      {mobileHeader?.actionsRight?.find((a) => a.icon === Filter)?.showBadge && (
                        <span
                          className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full border border-white z-10 pointer-events-none"
                          style={{ backgroundColor: mobileHeader?.actionsRight?.find((a) => a.icon === Filter)?.badgeColor || '#0B5D1E' }}
                        />
                      )}
                    </Button>
                    <Button variant="ghost" size="icon" onClick={toggleTasksViewMode}>
                      {tasksViewMode === "category" ? <Palette className="h-5 w-5" /> : (tasksViewMode === "class" ? <Layers className="h-5 w-5" /> : <Clock className="h-5 w-5" />)}
                    </Button>
                  </>
                )}

                {isListingPage && (
                  <>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => window.dispatchEvent(new CustomEvent("listing-toggle-search"))}
                      title="Search"
                    >
                      <Search className="h-5 w-5" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="relative"
                      onClick={() => window.dispatchEvent(new CustomEvent("listing-toggle-filter"))}
                      title="Frontend Filters"
                    >
                      <Filter className="h-5 w-5" />
                      {mobileHeader?.actionsRight?.find((a) => a.icon === Filter)?.showBadge && (
                        <span
                          className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full border border-white z-10 pointer-events-none"
                          style={{ backgroundColor: mobileHeader?.actionsRight?.find((a) => a.icon === Filter)?.badgeColor || '#0B5D1E' }}
                        />
                      )}
                    </Button>
                  </>
                )}

                {isGrowthPage && (
                  <>
                    {(mobileHeader?.actionsRight && mobileHeader.actionsRight.length > 0) ? (
                      mobileHeader.actionsRight.map(({ icon: Icon, onClick, showBadge, badgeColor }, i) => (
                        <Button
                          key={i}
                          variant="ghost"
                          size="icon"
                          className="relative"
                          onClick={onClick}
                        >
                          <Icon className="h-5 w-5" />
                          {showBadge && (
                            <span
                              className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full border border-white z-10 pointer-events-none"
                              style={{ backgroundColor: badgeColor || '#0B5D1E' }}
                            />
                          )}
                        </Button>
                      ))
                    ) : (
                      <>
                        <Button variant="ghost" size="icon" onClick={() => window.dispatchEvent(new CustomEvent("growth-toggle-search"))}>
                          <Search className="h-5 w-5" />
                        </Button>
                        <Button variant="ghost" size="icon" className="relative" onClick={() => window.dispatchEvent(new CustomEvent("growth-toggle-filter"))}>
                          <Filter className="h-5 w-5" />
                        </Button>
                      </>
                    )}
                  </>
                )}

                {isCommunityPage && (
                  <Button
                    variant="ghost"
                    size="icon"
                    className="relative"
                    onClick={() => window.dispatchEvent(new CustomEvent("community-toggle-filter-drawer"))}
                    title="Select View"
                  >
                    <Filter className="h-5 w-5" />
                  </Button>
                )}

                {isHomePage && !isPremium() && false && (
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                      if (isIOSDevice()) {
                        setShowIOSAlert(true);
                      } else {
                        setIsUpgradeOpen(true);
                      }
                    }}
                  >
                    <Crown className="h-5 w-5" />
                  </Button>
                )}

                {isHomePage && (
                  <>
                    {SHOW_SHARE_APP && (
                      <Button variant="ghost" size="icon" onClick={handleShareApp} title="Share App">
                        <Share2 className="h-5 w-5" />
                      </Button>
                    )}
                    <Button variant="ghost" size="icon" onClick={onRefresh} title="Refresh">
                      <RotateCcw className="h-5 w-5" />
                    </Button>
                  </>
                )}
                {isSettingsPage && (
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => window.dispatchEvent(new CustomEvent("settings-toggle-search"))}
                    title="Search"
                  >
                    <Search className="h-5 w-5" />
                  </Button>
                )}
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setIsMenuDrawerOpen(true)}
                >
                  <AlignJustify className="h-5 w-5" />
                </Button>
              </div>
            </div>
          )}
          {/* Mobile Sub-header */}
          {!isDesktop && !showBrandHeader && mobileHeader && (
            <MobileHeader
              title={mobileHeader.title}
              iconLeft={mobileHeader.iconLeft}
              actionsRight={mobileHeader.actionsRight}
              isIntegrationsOpen={isIntegrationsOpen}
              onIntegrationsChange={setIsIntegrationsOpen}
              hasSelection={mobileHeader.hasSelection}
              onReassignClick={mobileHeader.onReassignClick}
            />
          )}
        </header>
      )}

      {/* Mobile Menu Button for non-home pages - Hidden since we're using bottom nav */}
      {!isHomePage && (
        <Button
          variant="ghost"
          size="icon"
          className="fixed top-4 left-4 z-50 lg:hidden bg-white border border-gray-200 shadow-sm opacity-0 pointer-events-none"
          onClick={handleDrawerToggle}
        >
          <Menu className="h-6 w-6" />
        </Button>
      )}

      {/* Coming Soon Dialog */}
      <ComingSoonDialog
        open={comingSoonOpen}
        onOpenChange={setComingSoonOpen}
      />

      <MobileAddPopup
        isOpen={showMobilePopup}
        onClose={() => setShowMobilePopup(false)}
        threadTypes={threadMetas}
        onOptionClick={handleMobilePopupOptionClick}
        canAddConnections={canAddConnections}
        canAddTasks={canAddTasks}
        canAddRecords={canAddRecords}
        currentPage={location.pathname}
      />

      {/* Menu drawer */}
      <MenuDrawer
        isOpen={isMenuDrawerOpen}
        onClose={() => setIsMenuDrawerOpen(false)}
      // onOpenChangePIN={() => setIsChangePINOpen(true)}
      />

      {/* Navigation Drawer - Only for Desktop */}
      <nav className="flex-shrink-0">
        {/* Mobile Drawer - Hidden since we're using bottom nav */}
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" className="w-80 p-0 md:hidden hidden">
            <DrawerContent isMobile={true} />
          </SheetContent>
        </Sheet>

        {/* Desktop Drawer */}
        <div
          className="hidden lg:block fixed left-0 top-0 h-full border-r border-sahi-border-color bg-white z-40"
          style={{ width: `${drawerWidth}px` }}
        >
          <DrawerContent isMobile={false} />
        </div>
      </nav>

      {/* Mobile Bottom Navigation */}
      <div
        className={cn(
          "fixed bottom-0 left-0 right-0 z-50 lg:hidden",
          showMobilePopup && "pointer-events-none"
        )}
      >
        <div
          // Updated shadow to 'shadow-[0_-5px_15px_rgba(0,0,0,0.1)]' to cast it UPWARDS
          className="bg-white border-t border-gray-200 shadow-[0_-5px_15px_rgba(0,0,0,0.1)] px-2 py-2 h-[70px]"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <div className="flex items-center justify-around max-w-sm mx-auto w-full">
            {routesInfo.map((item, index) => {
              if (item.show && item.showInMobNav) {
                return (
                  <React.Fragment key={`nav-item-${index}`}>
                    {renderBottomNavItem(item)}
                    {/* Commented out spacer for center + button */}
                    {/* {(item.text === "Threads" || item.text === "Inquiries") && (
                      <div className="w-6" />
                    )} */}
                  </React.Fragment>
                );
              }
            })}
          </div>
        </div>
      </div>

      <GlobalPullToRefresh location={location} isMobile={isMobile} />
      <main
        className={cn(
          "flex-1 transition-all duration-200 w-full",
          fullHeightPages.includes(location.pathname)
            ? "h-screen overflow-hidden" // Full screen height for correct-excel
            : "min-h-screen",
          // Responsive padding - optimized from first version
          // !noPaddingPages.includes(location.pathname) ? "p-3" : "py-3",
          // Responsive top padding based on page type
          // "pt-16 lg:pt-6 p-3 pb-3",
          isHomePage
            ? "pt-0"
            : (isReportPage || isCstrAn || isSegAn || isRegShAn) && isMobile
              ? "pt-16 "
              : isProductDemandPage
                ? "pt-16 pb-24 lg:pt-6 lg:px-6"
                : (location.pathname === "/listing" || location.pathname === "/directory" || location.pathname === "/community")
                  ? "pt-16 pb-20 lg:pt-6 lg:pb-6 px-3 lg:px-6"
                  : "pt-16 pb-24 lg:pt-6 px-3 lg:px-6", // Other pages without header
          // Desktop: account for sidebar
          "lg:ml-[85px]",
          isConnectionPage ? "overflow-x-auto" : ""
        )}
      >
        <div className={cn(location.pathname === "/threads-detail" ? "w-[95%] max-w-[95%]" : "w-full max-w-full", (location.pathname === "/listing" || location.pathname === "/directory" || location.pathname === "/community") && "h-full flex flex-col min-h-0")}>{children}</div>
        <ConnectionEntryDialog
          open={isConnectionDialogOpen}
          onOpenChange={setIsConnectionDialogOpen}
          triggerButton={false}
        />
        <ThreadEntry
          open={isThreadEntryOpen}
          onOpenChange={(open) => {
            setIsThreadEntryOpen(open);
            if (!open) setThreadEntryCalledFrom("");
          }}
          triggerButton={false}
          threadTypeID={selectedThreadTypeID}
          calledFrom={threadEntryCalledFrom}
          onThreadUpdated={() => {
            // Handle thread update if needed
            setIsThreadEntryOpen(false);
            setThreadEntryCalledFrom("");
            window.dispatchEvent(new CustomEvent("threads-updated"));
            if (location.pathname === "/threads-report" && selectedThreadTypeID == 2) {
              window.location.reload();
            }
          }}
        />
        <TaskEntry
          open={isTaskDialogOpen}
          onOpenChange={(open) => {
            setIsTaskDialogOpen(open);
            if (!open) {
              setTaskPrefillData(null);
            }
          }}
          triggerButton={false}
          prefilledData={taskPrefillData}
        />

        <TaskClassSelectorDrawer
          open={isTaskClassDrawerOpen}
          onOpenChange={setIsTaskClassDrawerOpen}
          onSelectClass={(classId) => {
            setTaskPrefillData({ taskClass: classId });
            setIsTaskDialogOpen(true);
          }}
        />
        <RecordEntry
          open={isInteractionDialogOpen}
          onOpenChange={setIsInteractionDialogOpen}
          triggerButton={false}
        />
        {/* User entry dialog */}
        <UserEntry
          isOpen={isUserEntryOpen}
          setIsOpen={(open) => setIsUserEntryOpen(open)}
          userData={null}
        />
        <ExpenseEntry
          open={isExpenseEntryOpen}
          onOpenChange={setIsExpenseEntryOpen}
          triggerButton={false}
        />
        <WebStoreConfig
          open={isWebStoreConfigOpen}
          onClose={() => setIsWebStoreConfigOpen(false)}
          onSuccess={() => {
            setIsWebStoreConfigOpen(false);
            setConfigRefreshTrigger((prev) => prev + 1);
            window.dispatchEvent(new CustomEvent("config-updated"));
          }}
        />

        {!isDesktop && (
          <ContractDropdown
            className="hidden"
            externalOpen={mobileDropdownType === "contract"}
            onExternalOpenChange={(isOpen) => {
              if (!isOpen) {
                setMobileDropdownType(null);
              }
            }}
            onContractTypeSelect={(contractType) => {
              setSelectedContractType(contractType);
              setIsContractEntryOpen(true);
              setMobileDropdownType(null);
            }}
          />
        )}

        {!isDesktop && (
          <TransactionDropdown
            className="hidden"
            externalOpen={mobileDropdownType === "transaction"}
            onExternalOpenChange={(isOpen) => {
              if (!isOpen) {
                setMobileDropdownType(null);
              }
            }}
            onTransactionTypeSelect={(transactionType) => {
              setSelectedTransactionType(transactionType);
              setIsTransactionEntryOpen(true);
              setMobileDropdownType(null);
            }}
          />
        )}
        {/* <ProfileDrawer
          isOpen={isProfileDrawerOpen}
          onClose={() => setIsProfileDrawerOpen(false)}
          userData={userData}
          onLogout={handleLogout}
        /> */}

        {!(isCommunityPage && !isDesktop && !SHOW_COMMUNITY) && ((!isDesktop && !shouldHideMobileAddButton && (
          // Old code: <FloatingFeedbackButton className="fixed bottom-24" />
          <FloatingFeedbackButton
            onAddClick={() => handleBottomNavClick({ isAddButton: true })}
            className="fixed bottom-24"
          />
        )) ||
          (isDesktop && <FloatingFeedbackButton />))}
      </main>
      {/* Contract Entry Dialog */}
      <ContractEntry
        isOpen={isContractEntryOpen}
        onClose={() => {
          setIsContractEntryOpen(false);
          setSelectedContractType(null);
        }}
        prefilledData={{
          contractType: selectedContractType,
        }}
        onContractSaved={() => {
          setIsContractEntryOpen(false);
          setSelectedContractType(null);
        }}
      />

      {/* Transaction Entry Dialog */}
      <TransactionEntry
        isOpen={isTransactionEntryOpen}
        onClose={() => {
          setIsTransactionEntryOpen(false);
          setSelectedTransactionType(null);
        }}
        prefilledData={{
          transactionType: selectedTransactionType,
        }}
        onTransactionSaved={() => {
          setIsTransactionEntryOpen(false);
          setSelectedTransactionType(null);
        }}
      />

      {/* Change PIN Dialog */}
      {/* <ChangePINDialog
        isOpen={isChangePINOpen}
        setIsOpen={setIsChangePINOpen}
        user={userData}
      /> */}

      {/* Upgrade Subscription Dialog */}
      {/* <UpgradeSubscription
        open={isUpgradeOpen}
        onClose={() => setIsUpgradeOpen(false)}
      /> */}
      <AlertBox
        open={showIOSAlert}
        onOpenChange={setShowIOSAlert}
        title="Manage Subscription"
        description="You can manage your subscription by logging into the desktop view."
        actions={[
          {
            label: "OK",
            value: "ok",
            variant: "default",
            className:
              "bg-sahi-primary-color text-white hover:bg-sahi-primary-color/90",
          },
        ]}
        onAction={() => setShowIOSAlert(false)}
      />
    </div>
  );
};
// Pages that already manage their own pull-to-refresh — skip the global one.
const PAGES_WITH_OWN_PTR = ["/", "/inq-dashboard", "/tasks"];

/**
 * Renders a global pull-to-refresh indicator for all window-scroll pages.
 * Attach touch listeners to `window` (scrollRef = null) so any page that scrolls
 * at the document level (Threads, Connections, Transactions, Orders, Expenses,
 * Reports, etc.) gets pull-to-refresh for free without touching each page.
 */
function GlobalPullToRefresh({ location, isMobile }) {
  const pathname = location?.pathname ?? "";
  const disabled = !isMobile || PAGES_WITH_OWN_PTR.includes(pathname);
  const { indicatorRef, iconRef, isRefreshing } = usePullToRefresh(
    null, // window scroll
    () => window.location.reload(),
    { disabled }
  );

  return (
    <div
      ref={indicatorRef}
      className="fixed left-0 right-0 flex justify-center pointer-events-none z-[60]"
      style={{ top: 16, transform: "translateY(0px)", opacity: 0, willChange: "transform, opacity" }}
    >
      <div className="bg-white shadow-md rounded-full p-2 flex items-center justify-center">
        <RotateCw
          ref={iconRef}
          className={`h-5 w-5 text-sahi-primary-color ${isRefreshing ? "animate-spin" : ""}`}
        />
      </div>
    </div>
  );
}

export default Main;
